var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPartnerGraysvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 73,
    viewBox: "0 0 98 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.592381 72.9336H43.7734V30.5742H14.7672C12.7093 18.7835 21.3164 7.13827 25.8771 2.78952L24.0163 0.00559235C8.21064 5.20226 1.81466 24.3331 0.592381 33.249V72.9336Z",
    fill: "white",
    fillOpacity: 0.49
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3307 72.9336H97.5117V30.5742H68.5054C66.4476 18.7835 75.0546 7.13827 79.6154 2.78952L77.7546 0.00559235C61.9489 5.20226 55.5529 24.3331 54.3307 33.249V72.9336Z",
    fill: "white",
    fillOpacity: 0.49
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartnerGraysvg);
export default __webpack_public_path__ + "static/media/partner-graysvg.94c773cb784c5efdb0d87eac2e20c873.svg";
export { ForwardRef as ReactComponent };